const mergeRefs = (refs) => {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null && ref !== void 0) {
        ref.current = value;
      }
    });
  };
};
const isMutableRefObject = (ref) => {
  return typeof ref !== "function" && ref !== null;
};
export {
  isMutableRefObject,
  mergeRefs
};
//# sourceMappingURL=refs.js.map
